export default __webpack_public_path__ + "static/media/Snd_TryM.efac6001.mp3";